import React from "react";

const Loading = () => {
  const barStyle = (delay) => ({
    width: "6px",
    height: "30px",
    backgroundColor: "#fd6f4cff",
    animation: "barAnimation 1s infinite ease-in-out",
    animationDelay: delay,
  });

  return (
    <div
      style={{
        height: "100vh",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f9f9f9",
        fontFamily: "sans-serif",
      }}
    >
      {/* Bar Loader */}
      <div style={{ display: "flex", gap: "6px" }}>
        <div style={barStyle("0s")}></div>
        <div style={barStyle("0.1s")}></div>
        <div style={barStyle("0.2s")}></div>
      </div>



      {/* Keyframes */}
      <style>
        {`
          @keyframes barAnimation {
            0%, 100% {
              transform: scaleY(0.6);
            }
            50% {
              transform: scaleY(1.2);
            }
          }
        `}
      </style>
    </div>
  );
};

export default Loading;
